import { render, staticRenderFns } from "./style-two.vue?vue&type=template&id=1bc23872&scoped=true&"
import script from "./style-two.vue?vue&type=script&lang=js&"
export * from "./style-two.vue?vue&type=script&lang=js&"
import style0 from "./style-two.vue?vue&type=style&index=0&id=1bc23872&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc23872",
  null
  
)

export default component.exports